import React from 'react'
import Autosuggest from 'react-autosuggest'
import { HiddenLabels } from '../'
import Input from '../SearchBar/Input'
import styled, { withTheme } from 'styled-components'
import { SVGIcon } from '..'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import AutosuggestHighlightMatch from 'autosuggest-highlight/match'
import AutosuggestHighlightParse from 'autosuggest-highlight/parse'
import { useAppContext } from '../../containers/App/Context'
import { getVersionIcon } from '../../helpers/utils'
import { NAV_MODULE_ICON } from '../../constants'

const Wrapper = styled.div`
  #search-input {
    border-right: none;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`

const renderInput = (
  inputProps,
  clearHandler,
  submitHandler,
  isFetching,
  theme,
  version
) => {
  let input

  const focus = () => {
    input && input.focus()
  }

  return (
    <Wrapper>
      <HiddenLabels.Label htmlFor="search-input">{`Search ${theme.getOption(
        'pageTitle'
      )} Support`}</HiddenLabels.Label>

      <Input version={version}>
        <input {...inputProps} ref={node => (input = node)} />
        <button className="search-button">
          <If condition={isFetching}>
            <FontAwesomeIcon icon={faSpinner} spin />
          </If>
          <If condition={!isFetching}>
            <SVGIcon src={getVersionIcon(NAV_MODULE_ICON.search, version)} />
          </If>
        </button>
      </Input>
    </Wrapper>
  )
}

const renderSuggestion = (suggestion, { query }) => {
  const matches = AutosuggestHighlightMatch(suggestion, query)
  const parts = AutosuggestHighlightParse(suggestion, matches)

  return (
    <span>
      {parts.map((part, index) => {
        const className = part.highlight
          ? 'react-autosuggest__suggestion-match'
          : null

        return (
          <span className={className} key={index}>
            {part.text}
          </span>
        )
      })}
    </span>
  )
}
const getSectionSuggestions = section => {
  return section.suggestions
}
const renderTitle = ({ title }) => {
  return <span>{title}</span>
}

const Suggest = ({
  autosuggestProps,
  clearHandler,
  submitHandler,
  isFetching,
  theme
}) => {
  const { versionKey: version } = useAppContext()
  return (
    <div aria-haspopup="true" className="autosuggest-no-scroll">
      <Autosuggest
        {...autosuggestProps}
        renderSuggestion={renderSuggestion}
        multiSection={true}
        getSectionSuggestions={getSectionSuggestions}
        renderSectionTitle={renderTitle}
        renderInputComponent={inputProps =>
          renderInput(
            inputProps,
            clearHandler,
            submitHandler,
            isFetching,
            theme,
            version
          )
        }
        focusInputOnSuggestionClick={false}
        id="essearch-autocomplete"
      />
    </div>
  )
}

export default withTheme(Suggest)



// WEBPACK FOOTER //
// ./src/components/ESSearch/Suggest.js